/*
 * @Author: Czy
 * @Date: 2024-08-14 10:52:36
 * @FilePath: /bikecat/src/utils/http.ts
 *
 */
import { CustomRequestOptions } from '@/interceptors/request'
import { useSysStore } from '@/store'
import i18n from '@/i18n'

const t = i18n.global.t

export const http = <T>(options: CustomRequestOptions) => {
  // 1. 返回 Promise 对象
  return new Promise<T>((resolve, reject) => {
    uni.request({
      ...options,
      dataType: 'json',
      // #ifndef MP-WEIXIN
      responseType: 'json',
      // #endif
      // 响应成功
      success(res) {
        // 状态码 2xx，参考 axios 的设计
        if (res.statusCode >= 200 && res.statusCode < 300) {
          if ((res.data as { code: number }).code === 401) {
            // 不再跳转登录页，只显示提示
            uni.showToast({
              icon: 'none',
              title: t('common.authFailed'),
            })
            reject(res.data)
          }
          if (
            (res.data as { code: number }).code === 503 ||
            (res.data as { code: number }).code === 500
          ) {
            uni.showToast({
              icon: 'none',
              title: (res as any).data.errorMsg || t('common.requestError'),
            })
            uni.reLaunch({ url: '/pages/error-page/index' })
          }

          // 2.1 提取核心数据 res.data
          resolve(res.data as T)
        } else if (res.statusCode === 401) {
          // 401错误 - 不再跳转登录页
          uni.showToast({
            icon: 'none',
            title: t('common.authFailed'),
          })
          reject(res)
        } else if (res.statusCode === 400) {
          resolve(res.data as T)
        } else {
          // 其他错误 -> 根据后端错误信息轻提示

          // !options.hideErrorToast &&
          uni.showToast({
            icon: 'none',
            title: (res as any).data.errorMsg || t('common.requestError'),
          })

          uni.reLaunch({ url: '/pages/error-page/index' })
          reject(res.data)
        }
      },
      // 响应失败
      fail(err) {
        // uni.showToast({
        //   icon: 'none',
        //   title: '网络错误，换个网络试试',
        // })
        reject(err)
      },
    })
  })
}

/**
 * GET 请求
 * @param url 后台地址
 * @param query 请求query参数
 * @returns
 */
export const httpGet = <T>(url: string, query?: Record<string, any>) => {
  return http<T>({
    url,
    query,
    method: 'GET',
  })
}

/**
 * POST 请求
 * @param url 后台地址
 * @param data 请求body参数
 * @param query 请求query参数，post请求也支持query，很多微信接口都需要
 * @returns
 */
export const httpPost = <T>(
  url: string,
  data?: Record<string, any>,
  query?: Record<string, any>,
  hostType?: string,
) => {
  return http<T>({
    url,
    query,
    data,
    method: 'POST',
  })
}

http.get = httpGet
http.post = httpPost
